/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companydetails_Businessdesc2Inputs */

const ja_company_companydetails_businessdesc2 = /** @type {(inputs: Company_Companydetails_Businessdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esports大会運営、配信制作及び配信技術、Web構築、コンサルティング、タレントマネージメント、その他関連業務。`)
};

const en_company_companydetails_businessdesc2 = /** @type {(inputs: Company_Companydetails_Businessdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esports operation and management, media programming production and broadcast, marketing, website development, e-commerce, consulting, dispatched workers and related activities.`)
};

/**
* | output |
* | --- |
* | "Esports operation and management, media programming production and broadcast, marketing, website development, e-commerce, consulting, dispatched workers and ..." |
*
* @param {Company_Companydetails_Businessdesc2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companydetails_businessdesc2 = /** @type {((inputs?: Company_Companydetails_Businessdesc2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companydetails_Businessdesc2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companydetails_businessdesc2(inputs)
	return en_company_companydetails_businessdesc2(inputs)
});
export { company_companydetails_businessdesc2 as "company_companyDetails_businessDesc" }